import { Brand, Stage, StageSchema } from '@org-avp/models';
import { getDefaultIdleApp } from '@org-avp/naap-models';

// Only environment variables prefixed with the `envPrefix` (configured in `vite.config.ts`) are exposed to the application.
// See: https://vitejs.dev/guide/env-and-mode.html#env-files
export const STAGE = StageSchema.parse(import.meta.env.RETAIL_PLATFORM_STAGE);

const NAAP_API_ENDPOINT_URL_MAP: Record<Stage, string> = {
  [Stage.DEVELOP]: 'https://api.naap.develop.avp.tech',
  [Stage.PREPROD]: 'https://api.naap.preprod.avp.tech',
  [Stage.PROD]: 'https://api.naap.avp.tech',
};
export const NAAP_API_ENDPOINT_URL = NAAP_API_ENDPOINT_URL_MAP[STAGE];

// Demo brand - always use AUDI for demo environments
const defaultIdleApp = getDefaultIdleApp(STAGE, Brand.AUDI);
if (!defaultIdleApp) {
  throw new Error(`No idle app configured for demo brand (AUDI) and stage ${STAGE}`);
}
export const DEMO_IFRAME_APP_URL = defaultIdleApp.url;

const DEMO_CONTROL_APP_API_DOMAIN_MAP: Record<Stage, string> = {
  [Stage.DEVELOP]: 'https://api.naap-demo-control-app.develop.avp.tech',
  [Stage.PREPROD]: 'https://api.naap-demo-control-app.preprod.avp.tech',
  [Stage.PROD]: 'https://api.naap-demo-control-app.avp.tech',
};
export const DEMO_CONTROL_APP_API_DOMAIN = DEMO_CONTROL_APP_API_DOMAIN_MAP[STAGE];

const PORTAL_URL_MAP: Record<Stage, string> = {
  [Stage.DEVELOP]: 'https://portal.develop.avp.tech',
  [Stage.PREPROD]: 'https://portal.preprod.avp.tech',
  [Stage.PROD]: 'https://portal.avp.tech',
};
export const PORTAL_URL = PORTAL_URL_MAP[STAGE];
